import script from "./period-selection-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./period-selection-item.vue?vue&type=script&lang=ts&setup=true"

import "./period-selection-item.vue?vue&type=style&index=0&id=21083abd&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21083abd"]])

export default __exports__